/****************************************************
 * Module Name:  mixBucketProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MixBucketProxy {
  static GetAllBucket = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllBucketMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllBucketDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    ).then((response) => callback(
      // Sorting by stonetype, shape, color, clarity, size
      response.sort((a, b) => {
        if (a.stonetypeseq !== b.stonetypeseq) return a.stonetypeseq - b.stonetypeseq; // Compare stonetype
        if (a.shapeseq !== b.shapeseq) return a.shapeseq - b.shapeseq; // Compare shape
        if (a.colorseq !== b.colorseq) return a.colorseq - b.colorseq; // Compare color
        if (a.clarityseq !== b.clarityseq) return a.clarityseq - b.clarityseq; // Compare clarity
        return a.sizeseq - b.sizeseq;                           // Compare size
      })
    ));
  };

  static GetAllBucketDetailMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/detail/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    ).then((response) => callback(
      // Sorting by stonetype, shape, color, clarity, size
      response.sort((a, b) => {
        if (a.stonetypeseq !== b.stonetypeseq) return a.stonetypeseq - b.stonetypeseq; // Compare stonetype
        if (a.shapeseq !== b.shapeseq) return a.shapeseq - b.shapeseq; // Compare shape
        if (a.colorseq !== b.colorseq) return a.colorseq - b.colorseq; // Compare color
        if (a.clarityseq !== b.clarityseq) return a.clarityseq - b.clarityseq; // Compare clarity
        return a.sizeseq - b.sizeseq;                           // Compare size
      })
    ));
  };

  static GetBelowMinQuantity = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/detail/belowminquantity",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    ).then((response) => callback(response));
  };

  static GetAboveMaxQuantity = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/detail/abovemaxquantity",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    ).then((response) => callback(response));
  };

  static GetSingleBucket = (bucketId, callback) => {
    let params = {
      id: bucketId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckBucketAvailable = (
    shapeid,
    colorid,
    sizeid,
    clarityid,
    stonetypename,
    callback
  ) => {
    let params = {
      shapeid,
      colorid,
      sizeid,
      clarityid,
      stonetypename
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddBucket = (bucket, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(bucket),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateBucket = (bucket, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(bucket),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStockReport = (bucket, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/bucket/detail",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(bucket),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllReportBucketTransactionByDate = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/salepurchase/query`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMixAvgReport = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/report/mixavg",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStonesByBucketId = (bucketId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/bucket/${bucketId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteStonesFromBucketId = (lstStoneIds, bucketid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/mix/${bucketid}/remove`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(lstStoneIds),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteBulkStonesFromBucketId = (lstStones, bucketid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/mix/${bucketid}/removebulk`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(lstStones),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getBucketDetailsByBucketId = (bucketid, callback) => {
    let params = {
      bucketid: bucketid,
    };
    restAPICall(
      Constants.MANAGER_URL + `/bucketdetail`,
      "get",
      Constants.userToken,
      params,
      undefined,
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetLatestMixProformaDetail = (customerid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/latestmixproforma/${customerid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}
